import { createSelector } from 'reselect';
import { getRoomLabelText } from '@utilities/common';

const selectCommon = (state: any) => state.common;
const selectUser = (state: any) => state.user;

const ROOM_TAB_REGEX = /ROOM/i;

export const selectRoomBillingRestaurant = createSelector(
    [selectCommon],
    (common) => common?.selectedRestaurant || [],
);

export const selectRoomBillingUser = createSelector(
    [selectUser],
    (user) => user?.user || {},
);

export const selectRoomList = createSelector(
    [selectCommon],
    (common) => {
        const tempTabs: any = common?.selectedRestaurant?.tabs;
        if (!tempTabs) {
            return [];
        }
        const roomNumArr: { label: string; value: string }[] = [];
        for (const roomNum in tempTabs) {
            if (ROOM_TAB_REGEX.test(roomNum)) {
                for (let i = 1; i <= tempTabs[roomNum]; i++) {
                    roomNumArr.push({
                        label: getRoomLabelText(roomNum, i),
                        value: `${roomNum}-${i}`,
                    });
                }
            }
        }
        return roomNumArr;
    },
);

export const selectRoomBillingUserPermissions = createSelector(
    [selectCommon, selectUser],
    (common, user) => {
        const restId = common?.selectedRestaurant?.docId;
        if (!user?.user?.roles || !restId) {
            return {};
        }
        return {
            ...common?.globalConfig?.permissions,
            ...(user.user.roles[restId]?.permissions),
        };
    },
);

export const selectRoomGSTSlab = createSelector(
    [selectCommon],
    (common) => common?.selectedRestaurant?.roomGSTSlab || {},
);

export const selectGuestListRestaurant = createSelector(
    [selectCommon],
    (common) => ({
        logo: common?.selectedRestaurant?.logo || '',
        managerSign: common?.selectedRestaurant?.managerSign || '',
        phone: common?.selectedRestaurant?.phone || '',
        email: common?.selectedRestaurant?.email || '',
        esign: common?.selectedRestaurant?.esign || '',
    }),
);

export const selectRoomBills = createSelector(
    [selectCommon],
    (common) => common?.roomBills,
);

export const selectSelectedRestaurant = createSelector(
    [selectCommon],
    (common) => common?.selectedRestaurant,
);

export const selectSelectedRestId = createSelector(
    [selectCommon],
    (common) => common?.selectedRestaurant?.docId || '',
);

export const selectUserRoles = createSelector(
    [selectUser],
    (user) => user?.user?.roles || {},
);
